var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMedAssist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.996,
    height: 45,
    viewBox: "0 0 59.996 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MED_ASSIST",
    "data-name": "MED ASSIST",
    transform: "translate(-86.029 -82.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2534",
    "data-name": "Path 2534",
    d: "M110.4,92.483l-15,15a2.607,2.607,0,0,0-.774,1.875l-1.875,12.026-6.725,6.724,7.5,7.5,18.75-18.75a2.652,2.652,0,1,0-3.752-3.749l-5.46,5.462.74-8.5,10.6-14.118a2.656,2.656,0,0,0-4-3.471Z",
    transform: "translate(0 -8.592)",
    fill: "#f26222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    d: "M381.1,82.016l-18.75,18.75a2.651,2.651,0,1,0,3.749,3.749l5.462-5.46-.74,8.5L360.233,121.67a2.654,2.654,0,0,0,4,3.468l15-15a2.611,2.611,0,0,0,.777-1.875L381.88,96.24l6.722-6.725Z",
    transform: "translate(-242.577 0)",
    fill: "#f26222"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMedAssist);
export default __webpack_public_path__ + "static/media/ic-medAssist.e2c53a57.svg";
export { ForwardRef as ReactComponent };